import { useState } from "react";
import { toast } from "react-hot-toast";
import { useDeleteAssignmentMutation } from "@features/assignments/assignmentsApi";
import AssignmentModal from "../Modals/AssignmentModal";
import DeleteIcon from "@admin/components/SVG/DeleteIcon";
import EditIcon from "@admin/components/SVG/EditIcon";

const Assignment = ({ assignment }) => {
  const { id, title, video_title, totalMark } = assignment || {};

  const [isModalOpen, setIsModalOpen] = useState(false);

  const openModal = () => {
    setIsModalOpen(true);
  };

  function closeModal() {
    setIsModalOpen(false);
  }

  const [deleteAssignment] = useDeleteAssignmentMutation(id);

  const handleDelete = async () => {
    const response = await deleteAssignment(id);
    if (response?.data) {
      toast.success("Assignment deleted successfully!");
    } else {
      toast.error("Assignment deleted failed!");
    }
  };

  const handleEdit = () => {
    openModal(id);
  };

  return (
    <tr>
      <td className="table-td">{title}</td>
      <td className="table-td">{video_title}</td>
      <td className="table-td">{totalMark}</td>
      <td className="table-td flex gap-x-2">
        <button onClick={handleDelete}>
          <DeleteIcon />
        </button>
        <button onClick={handleEdit}>
          <EditIcon />
        </button>
        <AssignmentModal
          assignmentId={id}
          open={isModalOpen}
          closeModal={closeModal}
        />
      </td>
    </tr>
  );
};

export default Assignment;
